.loadable-button {
  position: relative;
  display: inline-flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;

  > div {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;

    &.pending {
      // TODO: Sync with design on how we want to handle primary-soft pending coloring
      // filter: brightness(150%) saturate(50%);
      border-radius: inherit;
      background: inherit;
      color: inherit;
    }
    &.success {
      top: 1px;
      left: 1px;
      overflow: hidden;

      width: calc(100% - 2px);
      height: calc(100% - 2px);
      border-radius: inherit;
      color: var(--primary);
      white-space: nowrap;

      &::before {
        position: absolute;
        z-index: -1;
        left: 50%;
        width: 0;
        height: 100%;
        animation: expand ease-out var(--slow-s) forwards;
        background: var(--container);
        content: "";

        @keyframes expand {
          to {
            left: 0;
            width: 100%;
          }
        }
      }
    }
  }
}
